<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6z6gN9/image/9781467444897.jpg?1684886421003" alt="This image is the cover for the book A Theology of Grace in Six Controversies, Interventions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Theology of Grace in Six Controversies, Interventions
      </h1>
      <p class="bookDescription body article font2">
        <p>Few topics in theology are as complex and multifaceted as grace: over the course of centuries, many seemingly arbitrary distinctions and arcane debates have arisen around it. Edward Oakes, however, argues that all of these distinctions and debates are ultimately motivated by one central question: <i>What are God’s</i><i>intentions for the world?</i><br/>  <br/> In <i>A Theology of Grace in Six Controversies </i>Oakes examines issues relating to grace and points them back to that central question, illuminating and explaining what is really at stake in these debates. Maintaining that controversies clarify issues, especially those as convoluted as that of grace, Oakes works through six central debates on the topic, including sin and justification, evolution and original sin, and free will and predestination.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward T. Oakes, Robert Barron
      </h2>
      
      <p class="authorDescription body article">Edward T. Oakes, S.J., is professor of systematic theology at the University of St. Mary of the Lake / Mundelein Seminary in Mundelein, Illinois.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?454c7f9b